import PropTypes from 'prop-types'

import {List, Map} from 'immutable'

import DeputyBox from './DeputyBox'

import './myDeputies.scss'

const MyDeputies = props => (
  <div className='my-deputies'>
    <section className='deputy-boxes flex-container'>
      {
        props.deputies.map(deputy => (
          <DeputyBox
            {...props}
            key={deputy.get('id')}
            deputy={deputy}
          />
        ))
      }
    </section>
  </div>
)

MyDeputies.propTypes = {
  currentUser: PropTypes.instanceOf(Map),
  deputies: PropTypes.instanceOf(List),
  hasDeputyWithDeferredItems: PropTypes.bool,
  updateResource: PropTypes.func,
  userConfig: PropTypes.instanceOf(Map),
  goToAddDeputy: PropTypes.func
}

export default MyDeputies
